import { MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import styled from "styled-components"

import CountdownBanner from "areas/header/countdown-banner"
import stickyHeader from "areas/header/hoc/sticky-header"
import DesktopMenu from "areas/header/jewlr/menu/desktop"
// import Microbanner from "areas/header/microbanner"

import DesktopHeader from "./desktop-header"
import DesktopNav from "./desktop-nav"
import MobileHeader from "./mobile-header"

const DesktopHeaderContainer = styled(MediaBox).attrs((props) => ({
  bg: "white",
  greaterThanOrEqual: "desktop",
  style: {
    borderBottom: "1px solid #ccc",
    boxShadow: props.sticky ? "0 6px 10px -6px #bdbdbd" : "none",
  },
}))``

const HeaderContent = ({ desktopNavExp, location, sticky }) => {
  const isHomepage = location.pathname === "/" || location.pathname === ""

  return (
    <>
      <MediaBox
        {...(!isHomepage && desktopNavExp === 0 && { lessThan: "tablet" })}
      >
        <CountdownBanner />
      </MediaBox>
      <MediaBox lessThan="desktop" position="relative">
        {/* <Microbanner isMobile sticky={sticky} /> */}
        <MobileHeader sticky={sticky} />
      </MediaBox>
      <DesktopHeaderContainer sticky={sticky}>
        {desktopNavExp === 1 ? (
          <DesktopNav sticky={sticky} />
        ) : (
          <>
            <DesktopHeader sticky={sticky} />
            <DesktopMenu sticky={sticky} />
          </>
        )}
      </DesktopHeaderContainer>
      {!isHomepage && desktopNavExp === 0 && (
        <MediaBox greaterThanOrEqual="tablet">
          <CountdownBanner />
        </MediaBox>
      )}
    </>
  )
}

HeaderContent.propTypes = {
  desktopNavExp: PropTypes.number,
  location: PropTypes.object,
  sticky: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    desktopNavExp: state.experiment.desktopNav.variant_id,
  }
}

export default connect(mapStateToProps)(withRouter(stickyHeader(HeaderContent)))
